import AgoraRTCWEB, { IAgoraRTCClient, ICameraVideoTrack } from 'agora-rtc-sdk-ng';
import { message } from 'antd';
import httpApi from '@/apis/httpApi';
import VoiceFn from '@/views/Voice/fn';
import LocalStore from '@/utils/store';
import { isSpecialAccount } from './config';

let client: IAgoraRTCClient | null = null;
let localVideoTrack: ICameraVideoTrack | null = null;

export async function startLiveVideoSpecial(clarity: string, portrait?: boolean) {
  stopLiveVideoSpecial();

  client = AgoraRTCWEB.createClient({ mode: 'live', codec: 'h264' });
  client.setClientRole('host');

  const cameraID = localStorage.getItem('VIOCE-LIVECAMERA-DEVICE') ?? '';
  if (!cameraID) return message.warning('当前未在开播设置选择摄像头');

  const cameraDevice = await getCameraDevice(cameraID);
  if (!cameraDevice) return;

  const joinState = await joinChannel(client);
  if (!joinState) return;

  createAndPublishVideoTrack(cameraID, clarity, portrait);
}

async function getCameraDevice(cameraID: string) {
  try {
    const devices = await AgoraRTCWEB.getCameras();
    const cameras = devices.filter(device => device.kind === 'videoinput');
    const selectedCamera = cameras.find(camera => camera.deviceId === cameraID);
    if (selectedCamera) return true;
    console.log('请重新选择摄像头');
    message.warning('请重新选择摄像头');
    return false;
  } catch (error) {
    console.log('获取摄像头列表失败', error);
    message.warning('获取摄像头列表失败');
    return false;
  }
}

export async function getCameraDevices() {
  try {
    const devices = await AgoraRTCWEB.getCameras();
    return devices;
  } catch (error) {
    return [];
  }
}

function getRoomInfo() {
  const roomInfo = VoiceFn.getLocalInfo('roomInfo');
  const token = roomInfo?.roomDetail?.agoraToken || '';
  const mainRoom = roomInfo?.roomId === roomInfo?.mainRoomId;
  const mainChannel = `${roomInfo?.roomId || 0}`;
  const childChannel = `pcVoice${roomInfo?.roomId || 0}`;
  const channel = mainRoom ? mainChannel : childChannel;
  const info: any = LocalStore.getValue('React-ant-Admin-user');
  const mainUid = `${info.userinfo.id || 0}`;
  const childUid = `pcVoice${info.userinfo.id || 0}`;
  const uid = mainRoom ? mainUid : childUid;

  return {
    appid: httpApi.voice.agoraAppId,
    channel,
    token,
    uid
  };
}

async function joinChannel(client: IAgoraRTCClient) {
  try {
    const params = getRoomInfo();
    await client.join(params.appid, params.channel, params.token, params.uid);
    console.log('加入频道成功');
    return true;
  } catch (error: any) {
    console.log('加入频道失败', error);
    message.warning(error.message);
    return false;
  }
}

const clarityList = [
  {
    label: 'UHD',
    dimensions: {
      width: 1920,
      height: 1080
    },
    frameRate: 30
  },
  {
    label: 'HD',
    dimensions: {
      width: 1280,
      height: 720
    },
    frameRate: 15
  },
  {
    label: 'SD',
    dimensions: {
      width: 960,
      height: 540
    },
    frameRate: 15
  }
];

function getVideoConfig(clarity: string, portrait?: boolean) {
  const clarityInfo = clarityList.find((item: any) => item.label === clarity);
  if (portrait) {
    return {
      width: clarityInfo?.dimensions.height,
      height: clarityInfo?.dimensions.width
    };
  }
  return clarityInfo?.dimensions;
}

async function createAndPublishVideoTrack(cameraId: string, clarity: string, portrait?: boolean) {
  try {
    localVideoTrack = await AgoraRTCWEB.createCameraVideoTrack({
      cameraId,
      encoderConfig: getVideoConfig(clarity, portrait)
    });
    if (client) {
      await client.publish([localVideoTrack]);
      console.log('发布视频流成功');
    }
  } catch (error: any) {
    console.error('Failed to create or publish video track:', error);
    console.log(`error code: ${error.code}, error name: ${error.name}, error message: ${error.message}`);

    if (error.code === 'PERMISSION_DENIED') {
      message.warning('摄像头权限被拒绝');
    } else if (error.name === 'NotReadableError' || error.code === 'NOT_READABLE') {
      message.warning('摄像头被占用或其他问题导致无法捕获视频');
    } else if (error.message.includes('TrackStartFailed')) {
      message.warning('视频轨道启动失败');
    } else if (error.message.includes('TrackPublishFailed')) {
      message.warning('视频轨道发布失败');
    } else {
      message.warning('视频轨道创建失败：' + error.message);
    }
  }
}

export async function stopLiveVideoSpecial() {
  const info: any = LocalStore.getValue('React-ant-Admin-user');
  const account = info?.userinfo?.account;
  const isSpecial = isSpecialAccount(account ?? '');
  if (isSpecial && client && localVideoTrack) {
    try {
      await client.unpublish(localVideoTrack);
      await client.leave();
    } catch (error: any) {
      console.log('stopLiveVideoSpecial', error);
      // message.warning('stopLiveVideoSpecial: ' + error.message);
    }
  }
}
